export default {
  loading: 'A carregar preços…',
  default_modal: {
    title: 'Lista de preços padrão',
    description:
      'Os preços predefinidos que cada parceiro sem substituição própria herda. As alterações nunca afetam licenças em curso.',
    saved: 'Lista de preços padrão guardada.',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'Não foi possível carregar os dados de preços.',
    save_error: 'Não foi possível guardar — tente novamente.',
    prices_saved: 'Lista de preços guardada.',
    license_created: 'Licença criada.',
    lifecycle: {
      pause: 'Licença pausada.',
      resume: 'Licença retomada.',
      cancel: 'Licença cancelada.',
    },
  },
  price_book: {
    title: 'Lista de preços',
    read_only_notice:
      'Os preços do parceiro substituem a lista predefinida principal. As licenças em curso mantêm os preços bloqueados.',
    editing_notice: 'A editar — os novos preços aplicam-se apenas a licenças criadas a partir de agora.',
    columns: {
      service: 'Serviço',
      cost_price: 'Preço bruto ({{currency}}/mês, incl. IVA)',
    },
    add_ons: 'Extras',
    missing_price: '{{name}} está ativado mas não tem preço — defina um ou desative-o.',
    incomplete_tier:
      '{{name}} precisa de um preço de volume e do número de localizações ativas a partir do qual se aplica, ou de nenhum dos dois.',
    invalid_tier:
      'O preço de volume de {{name}} deve ser inferior ao seu preço padrão, a partir de, pelo menos, 2 localizações ativas.',
    tier: {
      from: 'Preço de volume a partir de',
      live_locations: 'localizações ativas',
      counted_one: 'Este parceiro conta com {{count}} localização licenciada ativa para o preço por volume.',
      counted_other: 'Este parceiro conta {{count}} localizações licenciadas ativas para o preço de volume.',
    },
    snapshot_note:
      'Os preços ficam bloqueados numa licença quando é criada — editar a lista nunca altera as licenças em curso.',
    types: {
      base: 'Base',
      add_on: 'Extra',
    },
  },
  volume_discount: {
    title: 'Desconto por volume',
    read_only_notice:
      'Quando uma fatura mensal atinge o limiar de licenças, o desconto é aplicado a todas as taxas de licença desse ciclo.',
    editing_notice: 'A editar — os novos valores aplicam-se a partir do próximo ciclo de faturação.',
    threshold_label: 'Limiar de licenças',
    percent_label: 'Desconto',
    invalid: 'Introduza um limiar de pelo menos 1 e um desconto entre 0 e 100%.',
    saved: 'Desconto por volume guardado.',
    note: 'Conta as licenças faturadas no próprio ciclo; os meses transitados são excluídos. 0% (o valor predefinido) desativa o desconto — caso contrário, seria acumulado com o preço por volume na lista de preços.',
  },
  licenses: {
    test_restaurant_unlicensable: 'Um restaurante de teste nunca é faturado, por isso não pode ter uma licença.',
    title: 'Licenças de restaurante',
    select_company: 'Selecionar um restaurante',
    add_license: 'Adicionar licença',
    no_companies: 'Este parceiro ainda não tem restaurantes.',
    no_licenses: 'Ainda não há licenças para este restaurante.',
    activated_at: 'Ativo desde',
    next_period_preview: 'Próximo mês (proporcional, antes do desconto por volume)',
    statuses: {
      active: 'Ativo',
      paused: 'Pausado',
      canceled: 'Cancelado',
    },
    columns: {
      product: 'Serviço',
      locked_price: 'Preço bloqueado / mês',
      quantity: 'Qtd',
      trial_ends: 'Grátis até',
    },
    price_tiers: {
      volume: 'Taxa de volume',
      locked: 'Preço legado',
    },
  },
  lifecycle: {
    pause: {
      action: 'Pausar',
      title: 'Pausar esta licença?',
      description:
        'Os dias pausados não são faturados. A licença mantém os preços bloqueados e pode ser retomada a qualquer momento.',
      confirm: 'Pausar',
    },
    resume: {
      action: 'Retomar',
      title: 'Retomar esta licença?',
      description: 'A faturação continua a partir de hoje aos preços bloqueados.',
      confirm: 'Retomar',
    },
    cancel: {
      action: 'Cancelar licença',
      title: 'Cancelar esta licença?',
      description:
        'O mês atual é faturado pro-rata até hoje. Esta ação não pode ser desfeita — uma nova licença seria criada aos preços atuais da lista.',
      confirm: 'Cancelar licença',
    },
  },
  add_license: {
    title: 'Adicionar uma licença',
    description:
      'Selecione os serviços para este restaurante. Os preços ficam bloqueados na licença aquando da criação.',
    per_month: ' / mês',
    create: 'Criar licença',
    no_priced_products:
      'Nenhum produto tem ainda um preço utilizável para este parceiro — defina primeiro a lista de preços.',
  },
};
